import React, {ReactElement} from "react";
import cuff_32 from "../assets/cuff_32.png";
import cuff_42 from "../assets/cuff_42.png";
import bulb from "../assets/bulb.png";
import adapter from "../assets/adapter.png";
import other from "../assets/other.png";
import connectors from "../assets/connectors.png";

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import DiamondIcon from '@mui/icons-material/Diamond';
import StarIcon from '@mui/icons-material/Star';

const iconNameToIcon: Record<string, ReactElement> = {
    standartCuff: <img
        src={cuff_32}
        alt="cuff"
        style={{
            width: "64px",
            height: "64px",
        }}
    />,
    bigCuff: <img
        src={cuff_42}
        alt="cuff"
        style={{
            width: "64px",
            height: "64px",
        }}
    />,
    bulbs: <img
        src={bulb}
        alt="bulb"
        style={{
            width: "64px",
            height: "64px",
        }}
    />,
    adapters: <img
        src={adapter}
        alt="adapter"
        style={{
            width: "64px",
            height: "64px",
        }}
    />,
    connectors: <img
        src={connectors}
        alt="connectors"
        style={{
            width: "64px",
            height: "64px",
        }}
    />,
    others: <img
        src={other}
        alt="other"
        style={{
            width: "64px",
            height: "64px",
        }}
    />,
    ADMIN: <AdminPanelSettingsIcon sx={{ color: "red"}} />,
    OPT: <StarIcon sx={{ color: "orange"}} />,
    SUPEROPT: <DiamondIcon sx={{ color: "blue"}}/>,
};

export { iconNameToIcon };
